<template>
  <div class="intersections">
    <div
      :class="{
        intersection: true,
        'intersection-top': intersection.position === 'top',
        'intersection-bottom': intersection.position === 'bottom'
      }"
      v-for="(intersection, i) in intersections"
      :key="'intersection' + i"
      :style="{
        left: intersection.x - intersectionWidth / 2 + 'px',
        width: intersectionWidth + 'px'
      }"
    >
      <span>
        {{ intersection.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Intersections",
  computed: {
    intersectionWidth() {
      return 300;
    },
    intersections() {
      const topScale = this.$store.state.imageFlipper.topScale;
      const bottomScale = this.$store.state.imageFlipper.bottomScale;

      let location = this.$store.state.geolocation.location;
      let totalDistance = this.$store.getters.totalDistance;

      if (!topScale || !bottomScale) return [];

      const buffers = {
        top: Math.abs(topScale.invert(window.innerWidth * 1.5)),
        bottom: Math.abs(bottomScale.invert(window.innerWidth * 1.5))
      };

      let intersections = this.$store.state.geolocation.intersections
        .map(i => ({
          ...i,
          d: i.location - location * totalDistance,
          position: i.north ? "top" : "bottom"
        }))
        .filter(p => Math.abs(p.d) < buffers[p.position]);

      // space out streets that are very close to each other (5-way intersections, etc)
      for (let i = 1; i < intersections.length; i++) {
        if (Math.abs(intersections[i].d - intersections[i - 1].d) < 0.01) {
          intersections[i - 1].d -= 0.01;
        }
      }

      return intersections.map(i => ({
        ...i,
        x: i.position === "top" ? topScale(i.d) : bottomScale(i.d)
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.intersection {
  font-family: Graphik;
  font-size: 15px;
  position: absolute;
  text-align: center;

  &-bottom {
    bottom: 0;
    transform: rotate(180deg);
  }
}
</style>
